import { Container, Grid, Typography } from "@mui/material";
import { FeatureItem } from "./featureItem";
import { Fade } from 'react-awesome-reveal';
import videoFile from "./../../../assets/nodecanvas-share.webp";
import { FeatureItemVideo } from "./featureItemVideo";
import pictureStyle from "./../../../assets/nodecanvas-style.webp";
import featuresPicture from "./../../../assets/02.webp";

const tiers = [

  {
    title: 'Free no registration',
    price: '0',
    description: [
      'Project accesible by URL',
      'Avaliable 365 dayZs',
      'Ads :(',
    ],
    buttonText: 'Start now !',
    buttonVariant: 'outlined',
  },

];

export const Features = () => {
  return (
    <Container id="features" style={{ scrollMarginTop: 80 }} alignItems="center">
      <Fade bottom duration={1000}>
        <Typography
          component="h2"
          variant="h2"
          align="center"
          color="text.primary"
          gutterBottom
          sx={{ marginBottom: 5, fontWeight: 400, marginTop: 5 }}
        >
          Features
        </Typography>
      </Fade>
      <Fade bottom duration={1000} >
        <Typography variant="body1" align="center" color="text.secondary" component="p" p={3} m={3} >
          Visualize, organize, and share your data—fast and easy with NodeCanvas.
        </Typography>
      </Fade>
      <Fade bottom duration={1000}>
        <Grid container spacing={5} justifyContent="center" >
          <Grid item xs={12}>
            <FeatureItem title="Visualization 🪄" text="Effortlessly visualize complex diagrams and networks with NodeCanvas. Personalize layouts, adjust node appearances, and style elements to vividly represent your data. If you need to create organization diagrams, tree diagrams or just diagram to represent your data, try NodeCanvas!" url={featuresPicture} /></Grid>
          <Grid item xs={12}>
            <FeatureItemVideo showAsImage={true}
              title="Share your work 🌍"
              text="Easily share your projects with anyone using a unique link—no registration required for viewers to access and explore your diagrams."
              url={videoFile}
            />
          </Grid>
          <Grid item xs={12} sx={{ position: "relative" }}>
            <FeatureItem
              title="Styling 🎨"
              text="Customize nodes, edges, and labels with styling tools. Use colors, sizes, and shapes to highlight key relationships and patterns."
              url={pictureStyle}
              heigth="400"
            />
          </Grid>
        </Grid>
      </Fade>

      <Fade bottom duration={1000} >
        <Typography variant="body1" align="center" color="text.secondary" component="p" p={3} m={6} >
          And many more ...
        </Typography>
      </Fade>
    </Container>
  );
};